import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { ActivityType } from 'gql';
import { SummaryTile } from './SummaryTile';
import { ActivityTypeColor } from 'modules/activities/types';

interface SummarySectionProps {
  totalOrganizations: number
  totalActivities: number
  totalIndividuals: number
  totalItemsDistributed: number
  previousTotalActivities?: number
  previousTotalIndividuals?: number
  previousTotalItemsDistributed?: number
}

export const SummarySection: React.FC<SummarySectionProps> = ({
  totalOrganizations,
  totalActivities,
  totalIndividuals,
  totalItemsDistributed,
  previousTotalActivities,
  previousTotalIndividuals,
  previousTotalItemsDistributed
}) => {
  const { formatMessage } = useIntl();

  return (
    <Stack spacing={2}>
      <Typography variant='h5'>{formatMessage({ id: 'Summary' })}</Typography>
      <Stack direction='row' gap={2} flexWrap='wrap'>
        <SummaryTile
          title={formatMessage({ id: 'Organizations' })}
          count={totalOrganizations}
          sx={{
            borderColor: '#F6D50E'
          }}
        />
        <SummaryTile
          title={formatMessage({ id: 'Activities' })}
          count={totalActivities}
          previousCount={previousTotalActivities}
          sx={{
            borderColor: '#76D2DD'
          }}
        />
        <SummaryTile
          title={formatMessage({ id: 'Individuals' })}
          count={totalIndividuals}
          previousCount={previousTotalIndividuals}
          sx={{
            borderColor: '#F57C00'
          }}
        />
        <SummaryTile
          title={formatMessage({ id: 'Items distributed' })}
          count={totalItemsDistributed}
          previousCount={previousTotalItemsDistributed}
          sx={{
            borderColor: ActivityTypeColor[ActivityType.Distribution]
          }}
        />
      </Stack>
    </Stack>
  );
};
